module.exports = __webpack_public_path__ + "static/media/cycle.bd11af1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cycle.png
// module id = 992
// module chunks = 4